export const DEFAULT_CANVAS_TITLE = "Untitled";
export const DEFAULT_PAGE_TITLE = DEFAULT_CANVAS_TITLE;
export const DEFAULT_REQUEST_PAGE_TITLE = "unnamed query";
export const CANVAS_NAME = { SINGULAR: "document", PLURAL: "documents" };
export const PAGE_NAME = { SINGULAR: "page", PLURAL: "pages" };
export const HOMEPAGE_ROUTE = "/d";
export const DOWNLOADS_PAGE = "https://www.moment.dev/download";
export const WORKSPACE_ROUTE = (workspaceName: string) => `/d/${workspaceName}`;
export const DOCUMENT_ROUTE = (workspaceName: string, documentId: string) =>
	`/d/${workspaceName}/${documentId}`;
export const DOCUMENT_PAGE_ROUTE = (workspaceName: string, documentId: string, pageSlug: string) =>
	`/d/${workspaceName}/${documentId}/${pageSlug}`;

export const LOCAL_WORKSPACE_NAME = "local";

export const LOCAL_WORKSPACE = {
	id: LOCAL_WORKSPACE_NAME,
	name: LOCAL_WORKSPACE_NAME,
	host: "",
	slug: LOCAL_WORKSPACE_NAME,
	// this is local workspace,
	// so the owner would be the client.
	owner: true,
	role: "owner" as const,
};
